import { Link } from "react-router-dom";
import sherwinBirds from "assets/sherwin_brds.png";

const ExpeditionCTA = () => {
  return (
    <section
      id="expedition-cta-section"
      className="relative overflow-hidden bg-gradient-to-br from-[#1c1611] to-[#2b2118] py-20 text-white max-[768px]:py-[60px]"
    >
      <div className="relative z-[2]">
        <div
          className="pointer-events-none absolute inset-0 opacity-50"
          style={{
            background:
              "url('data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 100 100%22><circle cx=%2250%22 cy=%2250%22 r=%221%22 fill=%22rgba(255,255,255,0.1)%22/><circle cx=%2220%22 cy=%2220%22 r=%220.5%22 fill=%22rgba(255,255,255,0.1)%22/><circle cx=%2280%22 cy=%2230%22 r=%220.8%22 fill=%22rgba(255,255,255,0.1)%22/><circle cx=%2230%22 cy=%2280%22 r=%220.6%22 fill=%22rgba(255,255,255,0.1)%22/><circle cx=%2270%22 cy=%2270%22 r=%220.4%22 fill=%22rgba(255,255,255,0.1)%22/></svg>') repeat",
          }}
        />
        <div className="container">
          <div className="relative z-[3] grid grid-cols-[2fr_1fr] items-center gap-16 max-[968px]:grid-cols-1 max-[968px]:gap-8 max-[968px]:text-center">
            <div className="max-w-[600px]">
              <h1 className="mb-8 text-5xl font-bold leading-tight text-white [text-shadow:2px_2px_4px_rgba(0,0,0,0.3)] max-[968px]:text-[2.5rem] max-[768px]:mb-6 max-[768px]:text-3xl">
                Everything You Need for Your Feathered Friends
              </h1>

              <div className="mb-10 text-lg leading-[1.7] text-white/95 max-[768px]:mb-8 max-[768px]:text-base">
                <p>
                  From <em className="font-semibold italic text-brand-amber">premium bird food and treats</em> to expert
                  veterinary care and training services, Mysher Aviary is your
                  one-stop destination for all things birds. Browse our curated
                  collection of
                  <strong>
                    {" "}
                    bird supplies, accessories, and professional services
                  </strong>{" "}
                  designed to keep your avian companions happy and healthy.
                </p>
              </div>

              <div className="mt-8">
                <Link
                  to="/store"
                  className="inline-block rounded-[30px] bg-brand-amber px-8 py-4 text-lg font-bold uppercase tracking-[1.5px] text-black no-underline shadow-[0_8px_20px_rgba(245,166,35,0.35)] transition-all duration-300 hover:-translate-y-1 hover:bg-brand-amber-dark hover:shadow-[0_12px_25px_rgba(245,166,35,0.5)] max-[768px]:px-7 max-[768px]:py-3.5 max-[768px]:text-base"
                >
                  SHOP NOW! 🛒
                </Link>
              </div>
            </div>

            <div className="relative flex items-center justify-center max-[968px]:mt-8">
              <img
                src={sherwinBirds}
                alt="Sherwin with his hand-raised parrots"
                className="w-full max-w-[380px] rounded-2xl border-[6px] border-[#c8a878] object-cover shadow-2xl max-[768px]:max-w-[300px]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpeditionCTA;
